// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useContext, useState} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_qs} from '../../../../hola/pub/lib/use_qs';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_show_promo} from '../free_proxy/use_show_promo';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';
import styles from './index.module.less';
import Icon_chart_pie from '../../img/icons/24/chart_pie.svg';
import Icon_gift from '../../img/icons/24/gift.svg';
import Icon_slider from '../../img/icons/24/slider02.svg';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {HP_card} from '../hp_cards';
import {Carusel} from '../carusel';
import {Button} from '../../../../hola/pub/lib/button';
import {Input} from '../../../../hola/pub/lib/input';
import {Select} from '../../../../hola/pub/lib/select';
import {Textarea} from '../../../../hola/pub/lib/textarea';

const feature_slides = cta_caption=>[
    {
        id: 'easy_setup',
        title: <div className={styles.feature_slide_title}>
          <span><Icon_chart_pie/> Easy Setup</span>
          <h4>Super Simple</h4>
        </div>,
        text: `At any given moment, you will have a real time view of the
            status of your account, so you always stay on top of your usage
            and spend.`,
        img: <img className="lazyload"
          data-src={toolip_img_url('homepage/easy_setup.svg')}/>,
        cta: {
            caption: cta_caption,
            to: '/dashboard',
        },
    },
    {
        id: 'free_tier',
        title: <div className={styles.feature_slide_title}>
          <span><Icon_gift/> TRY FOR FREE</span>
          <h4>Have a free run with our <br/>1-week trial plan</h4>
        </div>,
        text: `5 free toolip Proxies for you to try out. On the house. We won't
            even ask you for your credit card details! Go ahead, take them for
            a test drive.`,
        img: <img className="lazyload"
          data-src={toolip_img_url('homepage/free_tier.svg')}/>,
        cta: {
            caption: cta_caption,
            to: '/dashboard',
        },
    },
    {
        id: 'customizable',
        title: <div className={styles.feature_slide_title}>
          <span><Icon_slider/> Customizable</span>
          <h4>Huge Selection</h4>
        </div>,
        text: `Choose from over 70+ million proxies in over 195 countries
            countries and get accurate, timely data to accomplish your proxy
            tasks.`,
        img: <img className="lazyload"
          data-src={toolip_img_url('homepage/customizable.svg')}/>,
        cta: {
            caption: cta_caption,
            to: '/dashboard',
        },
    },
];

export interface I_feature_slide {
    id: string;
    icon: string;
    pretitle: string;
    title: string;
    text: string;
    img: string;
    img_alt: string;
    cta_caption: string;
    to: string;
}

const icons_map = {
    Icon_chart_pie: Icon_chart_pie,
    Icon_gift: Icon_gift,
    Icon_slider: Icon_slider,
};
const items_icons = [
    {
        value: 'Icon_chart_pie',
        rendered_item: <div>Icon_chart_pie <Icon_chart_pie /></div>,
        title: 'Icon_chart_pie',
    },
    {
        value: 'Icon_gift',
        rendered_item: <div>Icon_gift <Icon_gift /></div>,
        title: 'Icon_gift',
    },
    {
        value: 'Icon_slider',
        rendered_item: <div>Icon_slider <Icon_slider /></div>,
        title: 'Icon_slider',
    },
];

const prepare_slides_from_props = (slides: I_feature_slide[])=>{
    return slides.map(sl=>{
        const Icon = icons_map[sl.icon] || Icon_chart_pie;
        const img = sl.img.replace(`https://toolip.io/wp-content`,
            `https://cdn4.toolip.io/wp-content`);
        return {
            ...sl,
            title: <div className={styles.feature_slide_title}>
              <span><Icon/> {sl.pretitle}</span>
              <h4>{sl.title}</h4>
            </div>,
            img: <img className="lazyload" data-src={img} alt={sl.img_alt}/>,
            cta: {
                caption: sl.cta_caption,
                to: sl.to,
            },
        };
    });
};

export interface I_hp_feature_slide_props {
    title?: string;
    title_tag?: string;
    description?: string;
    slides?: I_feature_slide[];
}
export interface I_hp_feature_slide_ed_props {
    value: I_hp_feature_slide_props;
    on_change: (value:I_hp_feature_slide_props)=>void;
    on_cancel: ()=>void;
}

export const HP_feature_slides_editor = (props:I_hp_feature_slide_ed_props)=>{
    const [state, set_state] = useState(props.value || {});
    useEffect(()=>{
        set_state(props.value);
    }, [props.value]);
    const slides = state.slides || [];
    return <div>
      <Input size={'sm'} label={'title'} value={state.title || ''}
        on_change={v=>set_state({...state, title: v})}/>
      <Title_header_select value={state.title_tag} on_select={v=>
        set_state({...state, title_tag: v})}/>
      <Input size={'sm'} label={'description'} value={state.description || ''}
        on_change={v=>set_state({...state, description: v})}/>
      <p>Slides:</p>
      {slides.map((sl, i)=>{
        const change_slide = (field, value)=>{
            const slides_new = [...slides];
            slides_new[i] = {...slides_new[i]};
            slides_new[i][field] = value;
            set_state({...state, slides: slides_new});
        };
        return <div className={styles.one_slide_edit} key={i}>
          <Select items={items_icons} value={sl.icon} on_select={(n, v)=>{
            change_slide('icon', v);
          }} size={'sm'}/>
          <Input size={'sm'} label={'pretitle'} value={sl.pretitle || ''}
            on_change={v=>change_slide('pretitle', v)}/>
          <Input size={'sm'} label={'title'} value={sl.title || ''}
            on_change={v=>change_slide('title', v)}/>
          <Textarea placeholder={'text'} value={sl.text || ''}
            on_change={v=>change_slide('text', v)}/>
          <Input size={'sm'} label={'cta_caption'} value={sl.cta_caption || ''}
            on_change={v=>change_slide('cta_caption', v)}/>
          <Input size={'sm'} label={'to'} value={sl.to || ''}
            on_change={v=>change_slide('to', v)}/>
          <Input size={'sm'} label={'img'} value={sl.img || ''}
            on_change={v=>change_slide('img', v)}/>
          <Input size={'sm'} label={'Img Alt'} value={sl.img_alt || ''}
            on_change={v=>change_slide('img_alt', v)}/>
        </div>;
      })}
      <Button caption={'Add slide'} size={'sm'}
        on_click={()=>{
          set_state({...state, slides: [...slides, {
            id: `id${Date.now()}`,
            icon: 'Icon_chart_pie',
            pretitle: 'text after icon',
            title: 'Title of slide',
            text: 'Text inside the slide',
            img: 'https://toolip.io/wp-content/uploads/2024/07/'
              +'Group-1143422.png',
            img_alt: 'alt text',
            cta_caption: 'Get started',
            to: '/dashboard',
          }]});
        }}/>
      <br/>
      <Button caption={'Save'} size={'sm'}
        on_click={()=>props.on_change(state)}/>
      <Button caption={'Cancel'} size={'sm'} on_click={()=>props.on_cancel()}/>
    </div>;
};

export const HP_feature_slides = (props:I_hp_feature_slide_props)=>{
    const {theme} = useContext(Settings_context);
    const {show_promo} = use_show_promo();
    const cta_caption = show_promo ? 'Get started' : 'Try now';
    const {debug_tr} = use_qs();
    const {width, is_client} = use_screen();
    const slides_conf = props?.slides ? prepare_slides_from_props(props.slides)
        : feature_slides(cta_caption);
    const slides = slides_conf.map(s=>{
        return <HP_card key={s.id} {...s} cls={styles.hp_feature_slide} show
          color="light" />;
    });
    const {T} = use_translation_v({no_defaults: true});
    const title = props.title || 'Intuitive and simple to use';
    const description = props.description
      || 'Our features are custom made to optimize your workflow';
    return <section className={styles.hp_feature_slides}>
      <div className={styles.bg}/>
      <Dynamic_heading tag={props.title_tag}><T>{title}</T>
      </Dynamic_heading>
      <p className={theme.u1}><T>{description}</T></p>
      {(is_client||debug_tr) && <Carusel items={slides}
        slide_width={width < 768 ? 335 : width < 1024 ? 450 : 931}
        slide_height={width < 768 ? 392 : 416}
        list={width < 768 ? 3 : undefined}
      />}
    </section>;
};
